<!-- Header -->
<app-header></app-header>
<!-- end Header -->

<!-- Hero section -->
<div class="section-xl bg-gradient-1">
    <div class="container text-center">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <h6 class="d-inline-block bg-dark-03 border-radius px-3 py-2 line-height-100 font-small font-family-syne letter-spacing-1 mb-3">Innovate. Integrate. Accelerate.</h6>
                <h1 class="fw-light font-family-syne">Empowering Your Business with Cutting-Edge IT Solutions. Your
                    Trusted Partner in Digital Transformation</h1>
                    <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple lightbox-media-link mt-3" (click)="openPopup()"><i class="fas fa-play"></i>
                </a>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Hero section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/_r0vlyp33pw?si=6QvabQvNDeYzXpw9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Services section -->
<div class="n-margin-6">
    <div class="container">
        <div class="row icon-5xl g-4">
            <div *ngFor="let service of services" class="col-12 col-lg-4">
                <div [ngClass]="{'mt-lg-4': service.marginTop, 'bg-white-09': true, 'backdrop-filter-blur': true, 'border-radius': true, 'box-shadow': true, 'hover-float': true, 'p-4': true, 'p-lg-5': true}">
                    <i [class]="service.icon + ' text-gradient-1 mb-2'"></i>
                    <h4 class="font-family-syne">{{service.title}}</h4>
                    <p>{{service.description}}
                    </p>
                    <a class="button-text-2 button-text-theme mt-3" routerLink="/services">Learn more</a>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Clients section -->
<div class="section">
    <div class="container">
        <owl-carousel-o [options]="brandCarouselOptions" class="client-carousel">
            <ng-template carouselSlide *ngFor="let brand of brands">
                <div class="client-box">
                    <a routerLink="/">
                        <img [src]="brand.image" [alt]="brand.alt">
                    </a>
                </div>
            </ng-template>
        </owl-carousel-o><!-- end owl-carousel -->
    </div><!-- end container -->
</div>
<!-- end Clients section -->

<!-- About section -->
<div class="section pd-0 border-top">
    <div class="container-fluid pd-0">
        <div class="row align-items-center mr-0">
            <div class="col-12 col-lg-6 col-xl-6 pd-0">
                <img src="assets/images/about/about-img-1.jpg" alt="about-img">
            </div>
            <div class="col-12 col-lg-6 col-xl-6 pd-60">
                <div class="d-inline-block bg-gradient-1 px-3 py-2 border-radius mb-3">
                    <span class="font-family-syne font-small fw-medium line-height-100 text-light">Transforming
                        Technology into Business Success</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.
                    Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus
                    mus.</p>
                <!-- Progress bars -->
                <div class="mt-4">
                    <div *ngFor="let skill of skills" class="mt-4">
                        <div class="progress-box progress-theme">
                            <h6 class="fw-medium">{{ skill.name }}</h6>
                            <div class="animated-progress">
                                <div class="bg-gradient-1" [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"><span>{{ skill.level }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end row -->
    </div>
</div>
<!-- end About section -->

<!-- Team section -->
<div class="section border-top">
    <div class="container">
        <div class="mb-5">
            <div class="row text-center">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                    <div class="d-inline-block bg-gradient-1 px-3 py-2 border-radius mb-3">
                        <span class="font-family-syne font-small fw-medium line-height-100 text-light">Seamless IT
                            Solutions for a Smarter Future</span>
                    </div>
                    <h2 class="display-6 font-family-syne fw-medium text-gradient-1">Meet Creative Team</h2>
                </div>
            </div>
        </div>
        <div class="row gx-3 gy-4">
            <div *ngFor="let member of teams" class="col-12 col-sm-6 col-lg-3 team-style-01 text-center">
                <figure class="border-radius">
                    <div class="team-member-image">
                        <img src="assets/images/team/{{member.img}}" alt="{{member.name}}">
                        <div class="team-overlay bg-overlay-gradient border-radius"></div>
                    </div>
                    <figcaption
                        class="align-items-center justify-content-center d-flex flex-column pd-l-20 pd-r-20 pd-t-30 pd-b-30">
                        <span class="team-title d-block alt-font text-light font-family-syne">{{member.name}}</span>
                        <span class="team-sub-title d-block text-light font-family-syne">{{member.designation}}</span>
                        <div class="social-icon position-bottom">
                            <a *ngFor="let link of socialLinks" [href]="link.url" [class]="link.class"><i [class]="link.icon"></i></a>
                        </div>
                    </figcaption>
                </figure>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Team section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/parallax-bg.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <div class="row g-4">
                <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                    <h2 class="display-4 font-family-syne fw-medium">Ready to Elevate Your IT Strategy?</h2>
                    <p>Maecenas nec odio et ante tincidunt tempus. Nullam quis ante. Etiam sit amet orci eget eros
                        faucibus tincidunt.</p>
                    <a class="button button-lg button-radius button-outline-white mt-4" routerLink="/contact">Call Us</a>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Portfolio section -->
<div class="section pd-b-0">
    <div class="container-fluid pd-0">
        <div class="mb-5">
            <div class="row text-center mr-0">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                    <div class="d-inline-block bg-gradient-1 px-3 py-2 border-radius mb-3"><span class="font-family-syne font-small fw-medium line-height-100 text-light">Stay Ahead with Our IT Expertise</span></div>
                    <h2 class="display-6 font-family-syne fw-medium text-gradient-1">Our Recent Works</h2>
                </div>
            </div>
        </div>
        <div class="row portfolio-grid g-0 hover-style-1 mr-0">
            <div *ngFor="let item of works" class="col-12 col-md-6 col-lg-4 portfolio-item">
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img src="assets/images/portfolio/{{item.img}}" alt="{{item.title}}">
                    </div>
                    <a routerLink="/portfolio-two-column"></a>
                    <div class="portfolio-title">
                        <div>
                            <h5 class="font-family-syne fw-normal">{{item.title}}</h5>
                            <span>{{item.category}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- end portfolio-grid -->
    </div><!-- end container -->
</div>
<!-- end Portfolio section -->

<div class="section-sm">
    <div class="container">
        <div class="row g-4">
            <div *ngFor="let fact of funFacts" class="col-12 col-sm-6 col-md-3">
                <h2 class="fw-bold counter">{{fact.displayedNumber | number:'1.0-0'}}</h2>
                <h6 class="fw-medium font-family-syne">{{fact.desc}}</h6>
            </div>
        </div>
    </div>
</div>

<!-- Prices section -->
<div class="section bg-gray-lighter">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-12 col-lg-5">
                <div class="d-inline-block bg-gradient-1 px-3 py-2 border-radius mb-3">
                    <span class="font-family-syne font-small fw-medium line-height-100 text-light">Your Next Big IT
                        Solution Starts Here</span>
                </div>
                <h2 class="display-6 font-family-syne fw-medium text-gradient-1">Pricing Plans</h2>
            </div>
            <div class="col-12 col-lg-7">
                <div class="row g-4">
                    <div class="col-12 col-md-6" *ngFor="let plan of pricingPlans">
                        <div class="bg-white box-shadow hover-float border-radius p-4 p-lg-5" [ngClass]="plan.extraClass">
                            <h6 class="font-small font-family-syne letter-spacing-1">
                                <span class="text-gradient-1">{{ plan.title }}</span>
                            </h6>
                            <div class="mt-3">
                                <h1 class="line-height-100 font-family-syne fw-medium mb-0">
                                    ${{ plan.price }}
                                </h1>
                                <span>{{ plan.period }}</span>
                            </div>
                            <ul class="list-unstyled mt-4">
                                <li *ngFor="let feature of plan.features">{{ feature }}</li>
                            </ul>
                            <a class="button button-md button-font-2 button-theme button-gradient-1 button-rounded mt-4" href="#">
                                Choose Plan
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div><!-- end row(outer) -->
    </div><!-- end container -->
</div>
<!-- end Prices section -->

<!-- Testimonial section -->
<div class="section border-top">
    <div class="container">
        <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
            <ng-template carouselSlide *ngFor="let slide of slideStore">
                <!-- Testimonial box -->
                <div class="border-radius border p-4">
                    <div class="d-flex align-items-center mb-3">
                        <div class="d-inline-block me-3">
                            <img class="img-mask-avatar-sm" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
                        </div>
                        <div class="d-inline-block">
                            <h5 class="fw-normal m-0 line-height-140">{{slide.title}}</h5>
                            <span class="font-small fw-normal">{{slide.subtitle}}</span>
                        </div>
                    </div>
                    <p>{{slide.desc}}</p>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div><!-- end container -->
</div>
<!-- end Testimonial section -->
